import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const UserLoginPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  useEffect(() => {
    document.title = 'User Login | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('/api/client-admin/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Original-Host': window.location.hostname
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Store token and user data
        localStorage.setItem('tenant_admin_token', data.access_token);
        localStorage.setItem('tenant_admin_user', JSON.stringify(data.user));

        // Security: reactivated user must reset password before accessing the system.
        if (data.password_reset_required) {
          localStorage.setItem('force_password_reset', '1');
        } else {
          localStorage.removeItem('force_password_reset');
        }

        // Redirect based on user type
        if (data.user.user_type === 'admin' || data.user.role_slug === 'admin') {
          // Tenant Admin - redirect to admin dashboard
          window.location.href = '/admin/dashboard';
        } else {
          // Regular User - redirect to user dashboard
          window.location.href = '/user/dashboard';
        }
      } else {
        alert(data.message || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Network error. Please try again.');
    }
  };

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/certificate-verify">
          <div id="stick_right"></div>
        </Link>

        {/* User Login Content */}
        <div id="outer">
          <div id="icard_out">
            <center><h3 className="hea3ding3">USER LOGIN</h3></center>
            
            <form onSubmit={handleSubmit}>
              <input 
                className="admin_input" 
                type="text" 
                placeholder="Username" 
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <input 
                className="admin_input1" 
                type="password" 
                placeholder="Password" 
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <input 
                type="submit" 
                value="LOGIN" 
                className="admin_submit" 
              />
            </form>
          </div>
          <p className="text-center" style={{marginTop: '-50px'}}>
            <a href="/reset-password">Forgot Password?</a>
          </p>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default UserLoginPage;